<template>
  <div class="c-text">
    <p class="c-text__text"><slot></slot></p>
  </div>
</template>

<script>
export default {
  props: ["text"],
};
</script>
